export default "__VITE_ASSET__wACi004R__"